import { createSlice } from '@reduxjs/toolkit';

const comchatLabLoadingSlice = createSlice({
    name: 'comchatLabLoading',
    initialState: true,
    reducers: {
        update: (state, action) => {
            return action.payload ?? state;
        },
    },
});

export const { update } = comchatLabLoadingSlice.actions;
export default comchatLabLoadingSlice.reducer;
